export default {
	updateLoginStatus(state, value) {
		state.userIsLoggedIn = value
	},
	updateUserEmail(state, email){
		state.userEmail = email
	},
	updateSfcId(state, id){
		state.sfcId = id
	},
	updateTaxInfo(state, taxInfo){
		state.taxInfo = taxInfo
	},
	updateEnrollNowBannerVisibility(state, showOrHide){
		state.hideEnrollNowBanner = showOrHide
	},
	updateUpromiseBannerVisibility(state, showOrHide){
		state.hideUpromiseBanner = showOrHide
	},
	updateDismissUpromiseBannerVisibility(state, showOrHide){
		state.dismissUpromiseBanner = showOrHide
	},
	updateMenu(state, menu){
		state.menu = menu
	},
	updateFooter(state, footer){
		state.footer = footer
	},
	updateSfcSubscriptions(state, subscriptions) {
		state.sfcSubscriptions = subscriptions
	},
	updateBestPlansExitModalContent(state, content){
		state.bestPlansExitModalContent = content
	},
	updateTakeoverInfo(state, info){
		state.takeoverInfo = info
	},
	updateQuizInfo(state, info){
		state.quizInfo = info
	},
	updateTakeoverIsOpened(state, status){
		state.takeoverIsOpened = status
	},
	updateStateOfResidence(state, stateOfResidence) {
		state.stateOfResidence = stateOfResidence
	},
	updateHasA529Plan(state, hasA529Plan) {
		state.hasA529Plan = hasA529Plan
	},
	updateToCollegeSavingsModalComingFrom(state, toCollegeSavingsModalComingFrom){
		state.toCollegeSavingsModalComingFrom = toCollegeSavingsModalComingFrom
	},
	updateSavingsUser(state, user) {
		state.savingsUser = user
	},
	updateSavingsUserChildAvailablePlanPortfolios(state, data) {
		state.savingsUser.children[data.index].available_plan_portfolios = data.planPortfolios
	},
	updateClosePathModal(state, value){
		state.closePathModal = value
	},
	updateSavingsLearnSection(state, value){
		state.savingsLearnSection = value
	},
	updateChildAge(state, value){
		state.childAge = value
	},
	updatePlansToCompare(state, planToToggle){
		// We only need plan.id, plan.logo_url, plan.name
		let currentPlans = state.plansToCompare
		let currentPlanIds = currentPlans.map((plan) => plan.id)
		let newPlans = []
		if(currentPlanIds.indexOf(planToToggle.id) == -1){
			newPlans = currentPlans
			if(currentPlanIds.length < 3){
				newPlans.push(planToToggle)
			}
		}else{
			for(let plan of currentPlans){
				if(plan.id != planToToggle.id){
					newPlans.push(plan)
				}
			}
		}

		state.plansToCompare = newPlans
	},

	resetPlansToCompare(state){
		state.plansToCompare = []
	},

	updateStateFromIp(state, value){
		state.stateFromIp = value
	},

	updateCurrentIp(state, value){
		if(value && value != ""){
			state.currentIp = value
		}
	},

	updateCurrentCsjourney(state, csjourney){
		state.csjourney = csjourney
	},

	updateCurrentCsgifting(state, csgifting){
		state.csgifting = csgifting
	},
	resetCollegeSavingsUserOnboarding(state, value){
		state.collegeSavingsUserOnboarding = {
			userTypeError: true,
			taxFilingStatusError: true,
			householdInconmeError: true,
			childrenError: true,
			monthlyContributionError: true,
			howWeHelpError: true
		}
	},

	updateCollegeSavingsUserOnboarding(state, hash){
		state.collegeSavingsUserOnboarding[hash.part] = hash.value
	},

	updateGeneralData(state, value) {
		state.generalData = value
	},

	updateStatesWithoutTerritories(state, value) {
		state.statesWithoutTerritories = value
	},

	savePlanDetailsData(state, data) {
		state.planDetails = data
	},
	updateLastAdsUpdate(state, value) {
		state.lastAdsUpdate = value
	},

	updateSaiInputs(state, value) {
		state.saiInputs = value
	},

	updateSaiResult(state, value) {
		state.saiResult = value
	},

	updatePlansWithInstitutions(state, value){
		state.plansWithInstitutions = value
	},

	updateSavingsCenterLearnCollegeCostCollegeId(state, value){
		state.savingsCenterLearnCollegeCostCollegeId = value
	},

	updateSavingsCenterLearnCollegeCostHouseholdIncome(state, value){
		state.savingsCenterLearnCollegeCostHouseholdIncome = value
	},

	updateSavingsCenterLearnCollegeCostChildAge(state, value){
		state.savingsCenterLearnCollegeCostChildAge = value
	},

	updateSavingsCenterLearnCollegeCostChildAgeUpdated(state, value){
		state.savingsCenterLearnCollegeCostChildAgeUpdated = value
	},

	updateSavingsCenterLearnCollegeUsedInitialChildAge(state, value){
		state.savingsCenterLearnCollegeUsedInitialChildAge = value
	},

	updateSavingsCenterInterstitial(state, value){
		state.savingsCenterInterstitial = value
	}



}
